import { DocumentLocation, OfflineCacheEnabledByLocation } from '../../types';

export function computeOfflineCacheEnabledByLocation(
  fromState: OfflineCacheEnabledByLocation | undefined,
): OfflineCacheEnabledByLocation {
  const defaults: OfflineCacheEnabledByLocation = {
    [DocumentLocation.Feed]: false,
    [DocumentLocation.New]: true,
    [DocumentLocation.Later]: true,
    [DocumentLocation.Shortlist]: true,
    [DocumentLocation.Archive]: true,
  };

  if (!fromState) {
    return defaults;
  }

  return { ...defaults, ...fromState };
}


